import React from 'react'

import ArrowForwardIcon from '@mui/icons-material/ArrowForward'
import { Box, Divider, List, ListItem, ListItemText, Typography } from '@mui/material'

interface ITopBookingItemProps {
  bookingId: number
  firstCollectionAddress: any
  lastDeliveryAddress: any
  tariffName: string
  onSelectTopBooking: (bookingId: number) => void
  isSelected: boolean
}

const TopBookingItem = (props: ITopBookingItemProps) => {
  const {
    bookingId,
    firstCollectionAddress,
    lastDeliveryAddress,
    tariffName,
    onSelectTopBooking,
    isSelected,
  } = props

  const primaryTextColor = isSelected ? 'white' : 'text.primary'
  const secondaryTextColor = isSelected ? 'white' : 'text.secondary'
  const arrowColor = isSelected ? 'white' : undefined
  const itemBgColor = isSelected ? 'primary.main' : 'inherit'
  const containerBgColor = isSelected ? 'primary.light' : 'transparent'
  return (
    <Box
      display='flex'
      flexDirection='row'
      alignItems='center'
      bgcolor={containerBgColor}
      borderRadius={2}>
      <List sx={{ width: '100%', maxWidth: 360, bgcolor: 'background.paper' }}>
        <ListItem
          alignItems='flex-start'
          onClick={() => onSelectTopBooking(bookingId)}
          sx={{
            cursor: 'pointer',
            bgcolor: itemBgColor,
            borderRadius: 2,
          }}>
          <ListItemText
            primary={
              <Box display='flex' alignItems='center' gap={1}>
                <Typography variant='body1' component='span' color={primaryTextColor}>
                  {firstCollectionAddress.address.name}
                </Typography>
                <ArrowForwardIcon fontSize='small' htmlColor={arrowColor} />
                <Typography variant='body1' component='span' color={primaryTextColor}>
                  {lastDeliveryAddress.address.name}
                </Typography>
              </Box>
            }
            secondary={
              <React.Fragment>
                <Box display='flex' alignItems='center' gap={1}>
                  <Typography variant='body1' component='span' color={secondaryTextColor}>
                    {firstCollectionAddress.address.city}, {firstCollectionAddress.address.postcode}
                  </Typography>
                  <ArrowForwardIcon fontSize='small' htmlColor={isSelected ? 'white' : undefined} />
                  <Typography variant='body1' component='span' color={secondaryTextColor}>
                    {lastDeliveryAddress.address.city}, {lastDeliveryAddress.address.postcode}
                  </Typography>
                </Box>
                <Typography component='span' variant='body2' color={secondaryTextColor}>
                  Tariff: {tariffName}
                </Typography>
              </React.Fragment>
            }
          />
        </ListItem>
        <Divider variant='fullWidth' component='li' />
      </List>
    </Box>
  )
}
export default TopBookingItem
